/**
 * Extracts the value of a path parameter from a given URL pathname.
 *
 * @param paramName - The name of the path parameter to extract (e.g. "workspace", "organization").
 * @param pathname - Optional pathname string to extract from. Defaults to `window.location.pathname`.
 * @returns The value of the path parameter, or `null` if not found.
 *
 * @example
 * // Given the URL: /my-cropwise/workspace/abc123/organization/xyz456
 * getPathParam('workspace') // => "abc123"
 * getPathParam('organization') // => "xyz456"
 */
export function getPathParam(
  paramName: string,
  pathname: string = window.location.pathname
): string | null {
  const regex = new RegExp(`/${paramName}/([^/]+)`);
  const match = pathname.match(regex);
  return match?.[1] ?? null;
}
